import React from 'react';
import PropTypes from 'prop-types';

class CredentialCardFlip extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isFlipped: this.props.isFlipped,
			rotation: 0
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.isFlipped !== this.props.isFlipped) {
			this.setState({ isFlipped: nextProps.isFlipped });
			this.setState({ rotation: this.state.rotation + 180 });
		}
	}

	getComponent(key) {
		return this.props.children.filter(component => {
			return component.key === key;
		});
	}

	render() {
		const styles = {
			front: {
				transform: `rotateY(${this.props.infinite
					? this.state.rotation : this.state.isFlipped ? 180 : 0
				}deg)`,
				transition: `${this.props.flipSpeedBackToFront}s`,
				...this.props.cardStyles.front
			},
			back: {
				transform: `rotateY(${this.props.infinite
					? this.state.rotation + 180 : this.state.isFlipped ? 0 : -180
				}deg)`,
				transition: `${this.props.flipSpeedFrontToBack}s`,
				...this.props.cardStyles.back
			}
		};

		return (
			<div className="credential-card-flip">
				<div className="credential-card-flipper">
					<div className="credential-card-front" style={styles.front}>
						{this.getComponent('front')}
					</div>

					<div className="credential-card-back" style={styles.back}>
						{this.getComponent('back')}
					</div>
				</div>
			</div>
		);
	}
}

CredentialCardFlip.propTypes = {
	/**
	 * Styles passed as props.
	 */
	cardStyles: PropTypes.shape({
		front: PropTypes.object,
		back: PropTypes.object
	}),
	/**
	 * The two components to be flipped.
	 */
	children: (props, propName, componentName) => {
		if (React.Children.count(props[propName]) !== 2) {
			return new Error(`${componentName} requires two children.`);
		}
		return null;
	},
	/**
	 * The amount seconds to flip the card.
	 */
	flipSpeedBackToFront: PropTypes.number,
	/**
	 * The amount seconds to flip the card.
	 */
	flipSpeedFrontToBack: PropTypes.number,
	/**
	 * Changes the way the card is flipped.
	 */
	infinite: PropTypes.bool,
	/**
	 * The changes which part of the card is visible.
	 */
	isFlipped: PropTypes.bool
};

CredentialCardFlip.defaultProps = {
	cardStyles: {
		front: {},
		back: {}
	},
	flipSpeedBackToFront: 0.6,
	flipSpeedFrontToBack: 0.6,
	infinite: false,
	isFlipped: false
};

export default CredentialCardFlip;
